import type { TourDetailData } from "@/api/tour";

interface RouteInfoProps {
  detail: TourDetailData;
}

export default function RouteInfo({ detail }: RouteInfoProps) {
  // 从行程安排中提取景点
  const allSpots = detail.itinerary?.map((d) => d.attractions).filter(Boolean);
  const uniqueSpots = allSpots?.length > 0 ? [...new Set(allSpots)].join("、") : undefined;
  // 优先使用详情的 attractions 字段（接口直接返回的景点信息）
  const mainAttractions = detail.attractions || uniqueSpots;

  const rows: [string, string][] = [
    ["出发城市", detail.departure_city],
    ["目的地", detail.destinations],
    ["行程天数", detail.days_text],
    ["主要景点", mainAttractions],
    ["集合地点", detail.gather_place],
    ["集合时间", detail.gather_time],
    ["成团人数", detail.group_people > 0 ? `${detail.group_people}人` : undefined],
    ["费用包含", detail.fee_include?.length ? detail.fee_include.join("、") : undefined],
  ].filter((row): row is [string, string] => Array.isArray(row) && Boolean(row[1]));

  return (
    <div className="bg-white mt-2 px-5 py-4">
      <div className="text-sm font-semibold text-gray-800 mb-3">线路信息</div>
      {rows.length > 0 ? (
        <div className="rounded-2xl overflow-hidden" style={{ background: "#F8F9FC", border: "1px solid #ECEEF2" }}>
          {rows.map(([label, value], idx, arr) => (
            <div
              key={label}
              className="flex gap-3 px-4 py-3"
              style={{ borderBottom: idx < arr.length - 1 ? "1px solid #ECEEF2" : "none" }}
            >
              <span className="text-xs text-gray-400 w-16 flex-shrink-0 leading-relaxed">{label}</span>
              <span className="text-xs text-gray-700 flex-1 leading-relaxed">{value}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6">
          <span className="text-xs text-gray-400">暂无详细行程信息</span>
        </div>
      )}

      {/* 库存提示 */}
      {detail.stock !== undefined && detail.stock <= 10 && detail.stock > 0 && (
        <div className="mt-3 p-3 rounded-xl" style={{ background: "#FEF3C7" }}>
          <div className="text-xs font-semibold text-amber-700">库存紧张</div>
          <p className="text-xs text-amber-600 leading-relaxed mt-1">仅剩 {detail.stock} 个名额，抓紧预订！</p>
        </div>
      )}
    </div>
  );
}
